import {FAQEntry} from '../models/faq-entry.model';

export interface FAQResponse {
  data: FAQEntry[];
  count: number;
  page: number;
  pageCount: number;
  total: number;
}
